export interface VideoItem {
  id: string;
  title: string;
  cover: string;
  category: string;
  duration: string;
  views: string;
  rating: number;
  description: string;
  tags: string[];
  releaseDate: string;
}

export interface CategoryInfo {
  slug: string;
  name: string;
  icon: string;
  description: string;
}

export const categories: CategoryInfo[] = [
  { slug: 'dianshi', name: '电视剧', icon: 'ri-tv-line', description: '热播电视剧，海量剧集每日更新' },
  { slug: 'dianying', name: '电影', icon: 'ri-film-line', description: '院线大片、经典电影一网打尽' },
  { slug: 'zongyi', name: '综艺', icon: 'ri-live-line', description: '热门综艺节目，欢笑不停歇' },
  { slug: 'dongman', name: '动漫', icon: 'ri-rocket-line', description: '热血动漫，二次元世界任你游' },
  { slug: 'zhibo', name: '直播', icon: 'ri-broadcast-line', description: '实时直播，精彩瞬间不错过' },
  { slug: 'jilupian', name: '纪录片', icon: 'ri-earth-line', description: '精品纪录片，探索世界奥秘' },
  { slug: 'tiyu', name: '体育', icon: 'ri-football-line', description: '体育赛事，激情燃烧每一刻' },
  { slug: 'shaier', name: '少儿', icon: 'ri-star-smile-line', description: '少儿内容，陪伴快乐成长' },
];

export const allVideos: VideoItem[] = [
  {
    id: 'v001',
    title: '长安十二时辰',
    cover: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20dynasty%20drama%20scene%20with%20warriors%20in%20traditional%20armor%20standing%20on%20ancient%20city%20wall%20at%20sunset%2C%20cinematic%20lighting%2C%20epic%20atmosphere%2C%20warm%20golden%20tones%2C%20dramatic%20clouds%2C%20film%20poster%20style&width=800&height=450&seq=video-cover-v001&orientation=landscape',
    category: 'dianshi',
    duration: '45分钟/集',
    views: '12.8亿',
    rating: 9.2,
    description: '改编自马伯庸同名小说的古装悬疑剧，讲述了唐朝上元节前夕，长安城陷入危机，死囚张小敬与李必携手在十二时辰内拯救长安的故事。',
    tags: ['古装', '悬疑', '历史', '热门'],
    releaseDate: '2025-06-15',
  },
  {
    id: 'v002',
    title: '流浪地球3',
    cover: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20movie%20poster%20with%20astronauts%20looking%20at%20a%20giant%20planet%20in%20deep%20space%2C%20futuristic%20spaceships%2C%20dramatic%20orange%20and%20black%20color%20scheme%2C%20cinematic%20quality&width=800&height=450&seq=video-cover-v002&orientation=landscape',
    category: 'dianying',
    duration: '148分钟',
    views: '8.6亿',
    rating: 9.5,
    description: '太阳急速老化，持续膨胀，将在百年内吞没地球。人类在地球表面建造出巨大的推进器，带着地球踏上长达2500年的流浪之旅。',
    tags: ['科幻', '灾难', '冒险', '热门'],
    releaseDate: '2025-02-10',
  },
  {
    id: 'v003',
    title: '极限挑战第十季',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%20with%20group%20of%20celebrities%20laughing%20and%20having%20fun%20outdoors%2C%20bright%20colorful%20design%2C%20energetic%20vibe%2C%20game%20show%20atmosphere&width=800&height=450&seq=video-cover-v003&orientation=landscape',
    category: 'zongyi',
    duration: '90分钟/期',
    views: '5.2亿',
    rating: 8.9,
    description: '国内顶级户外挑战真人秀，明星嘉宾们将面临各种意想不到的极限挑战，在欢笑与汗水中展现真实自我。',
    tags: ['真人秀', '户外', '挑战', '搞笑'],
    releaseDate: '2025-07-01',
  },
  {
    id: 'v004',
    title: '灵笼·终章',
    cover: 'https://readdy.ai/api/search-image?query=Dark%20anime%20poster%20with%20futuristic%20mecha%20fighting%20monsters%20in%20post-apocalyptic%20world%2C%20dramatic%20lighting%2C%20detailed%20character%20design%2C%20epic%20battle%20scene&width=800&height=450&seq=video-cover-v004&orientation=landscape',
    category: 'dongman',
    duration: '25分钟/集',
    views: '6.3亿',
    rating: 9.6,
    description: '末日废墟中，人类最后的城市"灯塔"悬浮于天际。面对地面未知生物的威胁，猎荒者们为了人类的未来而战。',
    tags: ['科幻', '热血', '战斗', '国漫'],
    releaseDate: '2025-04-20',
  },
  {
    id: 'v005',
    title: '王者荣耀职业联赛春季赛',
    cover: 'https://readdy.ai/api/search-image?query=E-sports%20tournament%20stage%20with%20huge%20LED%20screens%20showing%20game%20action%2C%20professional%20gaming%20teams%20competing%2C%20excited%20crowd%2C%20colorful%20stage%20lights%2C%20grand%20arena&width=800&height=450&seq=video-cover-v005&orientation=landscape',
    category: 'zhibo',
    duration: '直播中',
    views: '3.5亿',
    rating: 9.0,
    description: '顶级MOBA游戏职业联赛春季赛火热进行中，十六支顶尖战队展开激烈角逐，争夺冠军荣耀。',
    tags: ['电竞', 'MOBA', '赛事', '直播'],
    releaseDate: '2025-08-01',
  },
  {
    id: 'v006',
    title: '舌尖上的中国第五季',
    cover: 'https://readdy.ai/api/search-image?query=Beautiful%20Chinese%20food%20documentary%20scene%20with%20steaming%20hot%20traditional%20dishes%20on%20wooden%20table%2C%20warm%20kitchen%20lighting%2C%20rustic%20Chinese%20village%20background%2C%20appetizing%20food%20photography&width=800&height=450&seq=video-cover-v006&orientation=landscape',
    category: 'jilupian',
    duration: '50分钟/集',
    views: '4.1亿',
    rating: 9.4,
    description: '穿越中国大江南北，探寻各地独特美食文化。从深山到海边，从市井到宫廷，每一道美食都承载着动人的故事。',
    tags: ['美食', '文化', '人文', '经典'],
    releaseDate: '2025-05-10',
  },
  {
    id: 'v007',
    title: 'NBA季后赛巅峰对决',
    cover: 'https://readdy.ai/api/search-image?query=NBA%20basketball%20playoff%20game%20action%20shot%20with%20player%20dunking%20dramatically%2C%20packed%20arena%20with%20excited%20fans%2C%20professional%20sports%20photography%2C%20intense%20atmosphere&width=800&height=450&seq=video-cover-v007&orientation=landscape',
    category: 'tiyu',
    duration: '直播中',
    views: '2.8亿',
    rating: 9.1,
    description: 'NBA季后赛激战正酣，东西部豪强为总冠军展开终极对决。顶级球星的巅峰表现，不容错过！',
    tags: ['篮球', 'NBA', '赛事', '热门'],
    releaseDate: '2025-08-05',
  },
  {
    id: 'v008',
    title: '小猪佩奇大电影',
    cover: 'https://readdy.ai/api/search-image?query=Cute%20colorful%20animated%20children%20movie%20poster%20with%20happy%20cartoon%20pig%20family%20playing%20in%20sunny%20meadow%2C%20bright%20cheerful%20colors%2C%20kids%20friendly%20design&width=800&height=450&seq=video-cover-v008&orientation=landscape',
    category: 'shaier',
    duration: '85分钟',
    views: '1.5亿',
    rating: 8.7,
    description: '佩奇和家人们开启了一段奇妙的冒险旅程。充满欢笑与温暖的亲子动画电影，适合全家一起观看。',
    tags: ['动画', '亲子', '欢乐', '启蒙'],
    releaseDate: '2025-03-08',
  },
  {
    id: 'v009',
    title: '狂飙·续',
    cover: 'https://readdy.ai/api/search-image?query=Dark%20crime%20drama%20scene%20with%20two%20men%20in%20suits%20facing%20off%20in%20rainy%20night%20street%2C%20neon%20lights%20reflecting%20on%20wet%20pavement%2C%20tense%20atmosphere%2C%20Chinese%20noir%20style&width=800&height=450&seq=video-cover-v009&orientation=landscape',
    category: 'dianshi',
    duration: '42分钟/集',
    views: '18.2亿',
    rating: 9.3,
    description: '扫黑除恶专项斗争持续深入，正义与邪恶的较量进入白热化阶段。一场跨越二十年的恩怨纠葛，最终迎来大结局。',
    tags: ['犯罪', '悬疑', '扫黑除恶', '爆款'],
    releaseDate: '2025-01-05',
  },
  {
    id: 'v010',
    title: '大话西游·重生',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20comedy%20movie%20poster%20with%20monkey%20king%20character%20holding%20magical%20staff%20under%20colorful%20sunset%20sky%2C%20romantic%20and%20humorous%20vibe%2C%20classic%20homage&width=800&height=450&seq=video-cover-v010&orientation=landscape',
    category: 'dianying',
    duration: '135分钟',
    views: '7.9亿',
    rating: 9.0,
    description: '至尊宝再次穿越时空，这一次他能否改写命运？经典IP全新演绎，笑中带泪的奇幻爱情故事。',
    tags: ['奇幻', '喜剧', '爱情', '经典'],
    releaseDate: '2025-08-01',
  },
  {
    id: 'v011',
    title: '奔跑吧兄弟·新篇章',
    cover: 'https://readdy.ai/api/search-image?query=Outdoor%20Chinese%20variety%20show%20with%20celebrities%20running%20on%20beach%20at%20sunset%2C%20dynamic%20action%20shot%2C%20joyful%20expressions%2C%20tropical%20setting&width=800&height=450&seq=video-cover-v011&orientation=landscape',
    category: 'zongyi',
    duration: '100分钟/期',
    views: '6.1亿',
    rating: 8.5,
    description: '全新阵容，全新挑战。兄弟团再度集结，开启新一轮充满欢笑与感动的冒险之旅。',
    tags: ['真人秀', '户外', '竞技', '搞笑'],
    releaseDate: '2025-06-20',
  },
  {
    id: 'v012',
    title: '深海迷航',
    cover: 'https://readdy.ai/api/search-image?query=Beautiful%20anime%20art%20of%20deep%20ocean%20with%20bioluminescent%20creatures%2C%20a%20young%20explorer%20in%20diving%20suit%2C%20mysterious%20underwater%20ruins%2C%20dreamy%20blue%20and%20teal%20color%20palette&width=800&height=450&seq=video-cover-v012&orientation=landscape',
    category: 'dongman',
    duration: '22分钟/集',
    views: '3.8亿',
    rating: 9.2,
    description: '少女潜水员在深海中发现了一座神秘古城，由此揭开了一段被遗忘的海洋文明传奇。',
    tags: ['冒险', '奇幻', '海洋', '国漫'],
    releaseDate: '2025-07-10',
  },
  {
    id: 'v013',
    title: '故宫·文物修复师',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20artisan%20carefully%20restoring%20ancient%20artifact%20in%20traditional%20workshop%2C%20warm%20natural%20light%20through%20wooden%20windows%2C%20detailed%20close-up%20of%20hands%20and%20tools&width=800&height=450&seq=video-cover-v013&orientation=landscape',
    category: 'jilupian',
    duration: '55分钟/集',
    views: '2.2亿',
    rating: 9.7,
    description: '走进故宫博物院文物修复室，见证国宝级文物从残破到重生的奇迹过程。修复师的匠心与坚守，令人动容。',
    tags: ['文化', '历史', '工匠', '经典'],
    releaseDate: '2025-04-01',
  },
  {
    id: 'v014',
    title: '世界杯预选赛亚洲区',
    cover: 'https://readdy.ai/api/search-image?query=Soccer%20match%20action%20shot%20with%20players%20celebrating%20goal%20in%20packed%20stadium%2C%20green%20pitch%2C%20dramatic%20stadium%20lights%2C%20national%20team%20jerseys&width=800&height=450&seq=video-cover-v014&orientation=landscape',
    category: 'tiyu',
    duration: '直播中',
    views: '4.5亿',
    rating: 9.3,
    description: '中国男足冲击世界杯关键战役！全国球迷翘首以盼，共同见证历史时刻。',
    tags: ['足球', '国家队', '赛事', '热门'],
    releaseDate: '2025-08-08',
  },
  {
    id: 'v015',
    title: '喜羊羊与灰太狼·星际冒险',
    cover: 'https://readdy.ai/api/search-image?query=Cute%203D%20animated%20scene%20with%20cartoon%20sheep%20and%20wolf%20characters%20in%20colorful%20space%20adventure%2C%20planets%20and%20stars%20background%2C%20bright%20and%20cheerful%20kids%20animation%20style&width=800&height=450&seq=video-cover-v015&orientation=landscape',
    category: 'shaier',
    duration: '90分钟',
    views: '2.0亿',
    rating: 8.6,
    description: '羊村小伙伴们乘坐飞船飞向太空，在浩瀚宇宙中展开惊险又有趣的星际冒险。',
    tags: ['动画', '冒险', '亲子', '欢乐'],
    releaseDate: '2025-07-25',
  },
  {
    id: 'v016',
    title: '大明风华·第二季',
    cover: 'https://readdy.ai/api/search-image?query=Historical%20Chinese%20drama%20scene%20with%20empress%20in%20magnificent%20traditional%20palace%20costume%2C%20grand%20imperial%20palace%20interior%2C%20golden%20warm%20lighting%2C%20luxurious%20Ming%20dynasty%20setting&width=800&height=450&seq=video-cover-v016&orientation=landscape',
    category: 'dianshi',
    duration: '48分钟/集',
    views: '9.5亿',
    rating: 8.9,
    description: '明朝宫廷权谋大戏，讲述一位传奇女子从平民到皇后的跌宕人生。华丽服饰、精彩剧情，不容错过。',
    tags: ['古装', '历史', '权谋', '宫廷'],
    releaseDate: '2025-05-28',
  },
];

export const featuredVideoIds = ['v002', 'v009', 'v001', 'v003', 'v004', 'v005'];

export function getVideosByCategory(slug: string): VideoItem[] {
  return allVideos.filter((v) => v.category === slug);
}

export function getVideoById(id: string): VideoItem | undefined {
  return allVideos.find((v) => v.id === id);
}